function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'973e1b78bdf11bb3e8fe3814fcbd8d01': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-thin-gold-corner_68x.png?v=16955337414580353821")','19f1a224a1d5f134dfa173ffa05a226c': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-thin-black-corner_68x.jpg?v=14233097765429865295")','05d9a5368d8e0b8ead5d9ef52f94c95e': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-thin-silver-corner_68x.png?v=12569656547196505440")','88f5d20f2b390076eecb7e98a0559994': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-thin-white-corner_68x.png?v=1516043112903913196")','72825bfc490faa85a2b7c13e5f492765': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-thin-walnut-corner_68x.png?v=15237683029018257824")','84fc64f123adf7b52e976fe53d910716': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-thin-maple-corner_68x.png?v=7388151845517232679")','3e18d25c261aeccf81165bdcc2b86739': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-thin-oak-corner_68x.png?v=14963843339205007961")','8ad3b8a0b037ae40301c58cc6599402d': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-thin-espresso-corner_68x.png?v=10690826258714847052")','9487f88376b04a7571f824f1b6ad9d96': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-thin-natural-corner_68x.png?v=13272416988203542115")','d47be4939ffbb4181780736c17eec505': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-plein-air-gold-corner_68x.png?v=8713769091398464682")','c5ed5bce7170b901213edc7cfc96becb': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-vintage-copper-corner_68x.png?v=8457353374098874629")','0ca8fcb9f9760ec068b697ed1a481110': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-black-gold-classic-corner_68x.png?v=14260044590048581467")','3df7a98d7e24749bb0a997b657888c43': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-concerto-black-gold-corner_68x.png?v=12714791525810663123")','5e0657d83e3223648820cadb11ae6d7a': 'url("//reflectionsofchrist.org/cdn/shop/files/frame-driftwood-gray-corner_68x.png?v=14450384584643896386")',};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
